import { gql } from '@apollo/client'

export const ADD_USER =  gql`
  mutation addUser( 
    $name: String!
    $userName: String!
    $email: String!
    $password: String!
  ){
    addUser( addUserInput: { 
      name: $name,
      userName: $userName,
      email: $email
      password: $password
    } ){
      _id
      userName
      email
    }
  }
`